/**
 * Cidades (código IBGE) onde há profissional na busca. Junto com as cidades de 10 mil
 * habitantes ou mais, são as "cidades em destaque": as que entram no sitemap
 * (scripts/gerar-sitemap.js), na página /diaristas e no bloco "Outras cidades" de pages/Cidade.jsx.
 *
 * Mantida À MÃO, e não consultada em tempo real: o sitemap é gerado sem rede, e a página da
 * cidade não consulta o banco (prompts/paginas-por-cidade.md). Profissional começou a atender em
 * cidade nova? O código entra aqui, e depois `npm run gerar:sitemap`. Sair daqui só tira a cidade
 * do sitemap e dos links: a página continua abrindo.
 *
 * Levantada em 2026-10-30 na produção, só com SELECT, com o recorte essencial da busca
 * (UsuarioRepositorio.findAllUsersCidade):
 *
 *   SELECT u.cidade, MAX(u.cidade_estado), COUNT(DISTINCT u.id)
 *   FROM usuarios u JOIN profissionais pr ON pr.id_usuario = u.id
 *   WHERE u.ativo = 1 AND pr.ativo = 1 AND pr.verificacao_status = 'APROVADA'
 *     AND pr.status IN ('PENDENTE', 'ATIVO', 'SUSPENSO')
 *     AND EXISTS (SELECT 1 FROM profissionais_dias pd
 *                 WHERE pd.id_profissional = pr.id AND pd.inativo IS NULL)
 *   GROUP BY u.cidade;
 *
 * Um código por linha, entre aspas simples: o script lê este arquivo por regex.
 */
export const CIDADES_ATENDIDAS = [
	'1302603', // Manaus - AM
	'1501402', // Belém - PA
	'2108603', // Pinheiro - MA
	'2304400', // Fortaleza - CE
	'2513406', // Santa Luzia - PB
	'3106200', // Belo Horizonte - MG
	'3118601', // Contagem - MG
	'3162922', // São Joaquim de Bicas - MG
	'3304557', // Rio de Janeiro - RJ
	'3506003', // Bauru - SP
	'3513801', // Diadema - SP
	'3520509', // Indaiatuba - SP
	'3526902', // Limeira - SP
	'3530607', // Mogi das Cruzes - SP
	'3538709', // Piracicaba - SP
	'3550308', // São Paulo - SP
	'3552403', // Sumaré - SP
	'4100202', // Adrianópolis - PR
	'4104808', // Cascavel - PR
	'4106902', // Curitiba - PR
	'4113700', // Londrina - PR
	'4119905', // Ponta Grossa - PR
	'4201307', // Araquari - SC
	'4202305', // Biguaçu - SC
	'4205407', // Florianópolis - SC
	'4209102', // Joinville - SC
	'4314902', // Porto Alegre - RS
	'5002704', // Campo Grande - MS
	'5200258', // Águas Lindas de Goiás - GO
	'5201108', // Anápolis - GO
];
